import { useCustomSuspenseQuery } from "@/hooks/use-graphql-client";

import { Room_DesignPage_Query } from "./query";

type Props = {
	hotelID: string;
	roomID: string;
};

export const useRoomArticleQuery = ({ hotelID, roomID }: Props) => {
	const { data } = useCustomSuspenseQuery(Room_DesignPage_Query, { variables: { hotelID, roomID } });

	return {
		data,
	};
};
